namespace RioERP.Reports {
    export namespace B2CGstReportSummaryService {
        export const baseUrl = 'Reports/B2CGstReportSummary';

        export declare function Create(request: Serenity.SaveRequest<B2CGstReportSummaryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<B2CGstReportSummaryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<B2CGstReportSummaryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<B2CGstReportSummaryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/B2CGstReportSummary/Create",
            Update = "Reports/B2CGstReportSummary/Update",
            Delete = "Reports/B2CGstReportSummary/Delete",
            Retrieve = "Reports/B2CGstReportSummary/Retrieve",
            List = "Reports/B2CGstReportSummary/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>B2CGstReportSummaryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
